export default "__VITE_ASSET__J1yMiZeX__"